module.exports = __webpack_public_path__ + "img/20190826134055402.7a288a96.jpg";